import React, { cloneElement } from 'react';
import { List, ReferenceField, Datagrid, TextField, DeleteButton, useRefresh, usePermissions,
useListContext, sanitizeListRestProps, TopToolbar, ExportButton, Filter, ReferenceInput, AutocompleteInput
} from 'react-admin';
import CustomDateField from '../components/CustomDateField';
import CustomInspectedFrequenciesField from '../components/CustomInspectedFrequenciesField';

const ActionButtons = (props) => {
    const {
        className,
        exporter,
        filters,
        maxResults,
        ...rest
    } = props;
    const {
        resource,
        displayedFilters,
        filterValues,
        showFilter,
    } = useListContext();

    return (
        <TopToolbar className="mb-3" {...sanitizeListRestProps(rest)}>
            {filters && cloneElement(filters, {
                resource,
                showFilter,
                displayedFilters,
                filterValues,
                context: 'button',
            })}
            <ExportButton />
        </TopToolbar>
    );
}

const InspectionFilter = (props) => {
    return (
        <Filter {...props}>
            <ReferenceInput source="system_id" label={<h6 className="px-2 small rounded" style={{ backgroundColor: 'rgb(250, 250, 250)' }}>System</h6>} resource="systems" reference="systems" filterToQuery={searchText => ({ name: searchText })} fullWidth variant="outlined" alwaysOn>
                <AutocompleteInput optionText="name" fullWidth variant="outlined" />
            </ReferenceInput>
        </Filter>
    )
};

const InspectionList = props => {
    const toRedirect = useRefresh();
    const p = usePermissions();
    const isAdmin = p.loaded && p.permissions && 'user' in p.permissions && 'admin' in p.permissions && p.permissions.admin;
    const inspectionDeleteButton = isAdmin ? (<DeleteButton redirect={toRedirect} />) : '';

    return (
        <>
            <h3 className="text-danger px-3 px-md-0 pt-3 pt-md-0" style={{ fontFamily: 'Arial, sans-serif' }}>Inspections</h3>
            <List {...props} title=" " filters={<InspectionFilter />} actions={<ActionButtons />} bulkActionButtons={false}>
                <Datagrid rowClick="show" className="table table-sm table-hover table-borderless">
                    <CustomDateField className="px-3" source="date" label={<h6 className="text-secondary px-3" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Date </h6>} />
                    <ReferenceField label={<h6 className="text-secondary px-3" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>System Name </h6>} source="system_id" resource="systems" reference="systems" link={isAdmin ? 'show' : ''}>
                        <TextField className="px-3 text-capitalize" source="name" />
                    </ReferenceField>
                    <ReferenceField label={<h6 className="text-secondary px-3" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Inspector </h6>} source="inspector_id" resource="inspectors" reference="inspectors" link={isAdmin ? 'show' : ''}>
                        <TextField className="px-3 text-capitalize" source="display_name" />
                    </ReferenceField>
                    <CustomInspectedFrequenciesField className="px-3 text-capitalize" label={<h6 className="text-secondary px-3" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Inspected </h6>} source="inspected" />
                    {inspectionDeleteButton}
                </Datagrid>
            </List>
        </>
    );
}

export default InspectionList;
